// Parameter
import { Moment } from 'moment';
import { Unit } from './unit.types';

export interface Parameter {
  id: number;
  name: string;
  description: string;
  baseUnit: Unit;
  measurementAllowed: boolean;
  visible: boolean;
}

export interface ParameterInputs {
  id: number;
  name: string;
  assetCycleScheduleType?: string;
  description: string;
  baseUnitId?: number;
  measurementAllowed: boolean;
  visible: boolean;
}

export interface TaskParameterAssetCycle {
  id: number;
  name: string;
  unit: {
    id: number;
    name: string;
    description: string;
    baseValueDataType: string;
    visible: boolean;
  };
  lastValue: string;
  period: number;
}

export enum BaseValueDataType {
  Bool = 'Bool',
  Int = 'Int',
  Float = 'Float',
  Date = 'Date',
  DateTime = 'DateTime',
  Text = 'Text',
}

export interface TaskParameterAssetCycleUpdate {
  taskId: number;
  id: number;
  value: string;
  threshold: string;
}

export interface ParameterMeasurable {
  id: number;
  parameterId: number;
  parameterName: string;
  unitName: string;
  unitBaseValueDataType: `Bool` | `Int` | `Float` | `Date` | `DateTime` | `Text`;
  measureToDate: string;
  value: any;
}

export interface ParameterMeasuredCreateMobile {
  assetParameterId: number;
  valueInt: number | null;
  valueBool: boolean;
  valueFloat: number | null;
  valueDate: Moment | null;
  valueDateTime: Moment | null;
  valueText: string;
}

export interface ParameterMeasurableLast {
  assetParameterName: string;
  unitName: string;
  unitDataType: `Bool` | `Int` | `Float` | `Date` | `DateTime` | `Text`;
  created: string;
  value: any;
}
